import * as React from 'react';

import { Loader2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@crm/shared/lib/styles/utils';

const Spinner = ({ className, ...props }: React.ComponentProps<'svg'>) => {
    const { t } = useTranslation();

    return (
        <Loader2Icon
            role="status"
            aria-label={t('loading.text')}
            className={cn('size-4 animate-spin', className)}
            {...props}
        />
    );
};

export { Spinner };
